import * as $ from "jquery";
import * as _ from "lodash";
import { Utils } from "../../../../common/utils";
import { DashboardChannel } from "../../../../models/DashboardChannel";
import { GetSeriesOptions } from "../../../dashboard/widgets/ChartWorkerManager";
import { BaseDashboardWidgetView, BaseDashboardWidgetViewOptions } from "../../../dashboard/widgets/_BaseWidgetView";
import {
    CHART_AGGREGATION_PERIOD,
    CHART_AGGREGATION_TYPE,
    CHART_TYPE,
    ChartConfig,
    ChartHelper,
    minMaxTimeStampOptions
} from "../../../dashboard/widgets/chart/ChartHelper";
import { getAggFunctionName } from "../../ReportUtils";
const moment = require("moment-timezone");

declare var App: any;

export class TotalWidgetView extends BaseDashboardWidgetView {

    private lastRenderedChannelIds: number[] = [];
    private template = _.template(require('templates/dashboard/widgets/widgetWrapper.html'));
    private channelsTemplate = _.template(require('templates/reports/widgets/totalwidget/channels.html'));
    private datapoints: {} = {};
    private totalledDashboardChannelIds = [];
    private minDataRequested: number = Infinity;
    private maxDataRequested: number = null;
    private advancedConfig = false;
    private useCustomLabels = true;

    constructor(options: BaseDashboardWidgetViewOptions) {
        super(<any>_.merge({
            tagName: "div",
            className: options.report ? 'widget widget-w-6' : 'widget widget-w-1',
            events: {
                // Widget related buttons
                'click .w-settings .remove': 'handleRemoveWidgetClick',
                'click .w-delete-widget .w-cancel': 'handleRemoveWidgetCancelClick',
                'click .w-delete-widget .w-confirm': 'handleRemoveWidgetConfirmClick',
                'click .w-settings .gear': 'handleEditWidgetClick',
                'click .w-settings .clone': 'handleCloneWidget'
            }
        }, options));

        const rawUseCustomLabelsConfig = this.options.widget.getParamValue('USE_CUSTOM_LABELS', true);
        // coerce the raw value -- which may be a boolean, number, or string -- into a boolean
        this.useCustomLabels = !!Number(rawUseCustomLabelsConfig);
    }

    render() {
        this.$el.html(this.template({
            dashboardId: this.options.dashboardId,
            permissionCollection: this.options.permissionCollection,
            widget: this.options.widget,
            editable: this.options.editable,
            movable: this.options.movable,
            cloneable: this.options.cloneable,
            deletable: this.options.deletable
        }));
        this.$el.attr('data-widget-id', this.options.widget.get('id'));

        var preDataFetchLayout = [{
            name: '',
            unit: '',
            value: '',
            aggFunctionName: '',
            id: null,
            state: null,
        }];
        this.$('.total-widget').html(this.channelsTemplate({
            channels: preDataFetchLayout,
            // Adjust channel widths for total widgets
            channelWidth: '100%',
            loading: true,
        }));

        // Get channels for total widget
        var widgetId = this.options.widget.get('id');
        var widgetChannels = <DashboardChannel[]>this.options.dashboardChannelCollection.where({ dashboard_widget_id: widgetId });

        // Get data for total widget
        var dashboardChannelIds = _.map(widgetChannels, (channel) => channel.get('dashboard_channel_id'));

        $.when(this.getData(dashboardChannelIds)).then(() => {
            this.renderTotalWidgetChannels();
        });

        return this;
    }

    private setTimestamps(dashboardChannelIds) {
        var aggregationParam = this.options.widget.getParamValue('CHART_AGGREGATION_TYPE', CHART_AGGREGATION_TYPE.DEFAULT);
        var aggregationTypes = _.map(_.split(aggregationParam, ','));
        var isPeriodDelta = _.includes(aggregationTypes, CHART_AGGREGATION_TYPE.MAXDIFF);

        _.each(dashboardChannelIds, (id) => {
            var channel = this.options.dashboardChannelCollection.findWhere({ dashboard_channel_id: Number(id) });
            var initial = this.minDataRequested === Infinity;

            var baseMinMaxOptions = {
                initial: initial,
                channel: channel,
                widget: this.options.widget,
                customDataRangeFunc: null,
                isDefaultChart: false,
                dashboardChannelCollection: this.options.dashboardChannelCollection,
                graphedDashboardChannelIds: this.totalledDashboardChannelIds,
                user: this.options.currentUser
            };
            var maxOptions: minMaxTimeStampOptions = _.extend(baseMinMaxOptions, {
                maxDataRequested: this.maxDataRequested
            });
            var max = ChartHelper.getMaxTimestampToRequest(maxOptions);
            if (max > this.maxDataRequested) this.maxDataRequested = max;

            var minOptions: minMaxTimeStampOptions = _.extend(baseMinMaxOptions, {
                minDataRequested: this.minDataRequested,
                maxDataRequested: this.maxDataRequested
            });
            var min = ChartHelper.getMinTimestampToRequest(minOptions);
            if (min < this.minDataRequested) this.minDataRequested = min;
        });

        // request enough data for period delta to make a dif between two points
        // TODO remove this hack and add logic to .processData in chartworker somehow.
        if (isPeriodDelta) {
            var diffTime = this.maxDataRequested - this.minDataRequested;
            this.minDataRequested = this.minDataRequested - diffTime;
        }
    }

    getData(dashboardChannelIds: number[]) {
        this.setTimestamps(dashboardChannelIds);
        var deferred = $.Deferred();
        var period = this.options.widget.getParamValue('CHART_AGGREGATION_PERIOD', CHART_AGGREGATION_PERIOD.DEFAULT);
        var aggregationParam = this.options.widget.getParamValue('CHART_AGGREGATION_TYPE', CHART_AGGREGATION_TYPE.DEFAULT);
        var chartConfig: ChartConfig = {
            seriesGroups: [{
                type: CHART_TYPE.WIDGET_MULTI_SERIES_SINGLE_POINT,
                period: period,
                series: _.map(dashboardChannelIds, (dashboardChannelId) => {
                    var dashboardChannel = this.options.dashboardChannelCollection.findWhere({ dashboard_channel_id: dashboardChannelId });
                    var aggregationTypes = _.map(_.split(aggregationParam, ','));
                    var order = dashboardChannel.get('dashboard_channel_order');


                    // get agg type by dashboard channel order
                    var aggType;
                    if (period === CHART_AGGREGATION_PERIOD.NONE) {
                        aggType = CHART_AGGREGATION_TYPE.NONE;
                    } else if (order && order < aggregationTypes.length) {
                        aggType = aggregationTypes[order];
                    } else {
                        aggType = aggregationTypes[0];
                    }

                    return {
                        agg: aggType,
                        tag: dashboardChannelId,
                        channelId: dashboardChannel.get('channel_id'),
                        name: dashboardChannel.get('channel_name')
                    }
                })
            }],
            timezone: ChartHelper.getChartTimezone(this.options.widget, this.options.currentUser),
            showThresholdPlotlines: false,
            realTimestamps: false,
            hideSingleGaps: true,
            convertAllValues: true,
            labels: false
        };

        var getSeriesChannels: any = {};
        _.each(dashboardChannelIds, (dashboardChannelId) => {
            var dashboardChannel = this.options.dashboardChannelCollection.findWhere({ dashboard_channel_id: dashboardChannelId });
            getSeriesChannels[dashboardChannel.get('channel_id')] = {
                id: dashboardChannel.get('channel_id'),
                sensor_type: dashboardChannel.get('sensor_type'),
                sensor_connector: dashboardChannel.get('sensor_connector'),
                sensor_version: dashboardChannel.get('sensor_version'),
                position: dashboardChannel.get('channel_position'),
                channel_secret: dashboardChannel.get('channel_secret'),
                last_timestamp: dashboardChannel.get('channel_last_timestamp') || moment().unix(),
                polling_frequency: dashboardChannel.get('module_polling_frequency'),
                tags: [dashboardChannelId]
            }
        });

        // Fetch one more day's worth of data for period delta channels to compare
        var startTimestamp;
        if (this.options.widget.getParamValue('CHART_AGGREGATION_TYPE', null) &&
            this.options.widget.getParamValue('CHART_AGGREGATION_TYPE', null) === CHART_AGGREGATION_TYPE.MAXDIFF) {
            startTimestamp = this.minDataRequested - 86400
        } else {
            startTimestamp = this.minDataRequested;
        }


        var getSeriesOptions: GetSeriesOptions = {
            chartConfig: chartConfig,
            channels: getSeriesChannels,
            startTimestamp: startTimestamp,
            endTimestamp: this.maxDataRequested
        };

        $.when(this.options.chartWorkerManager.getSeries(getSeriesOptions)).then((data) => {

            // keyed by chart type
            // multi channel series is located at index 0
            this.datapoints = data[CHART_TYPE.WIDGET_MULTI_SERIES_SINGLE_POINT][0];

            deferred.resolve();
        });
        return deferred;
    }

    handleRemoveWidgetConfirmClick() {
        super.handleRemoveWidgetConfirmClick();
    }

    handleEditWidgetClick() {
        this.options.widget.once('sync', () => {
            this.options.dashboardChannelCollection.once('sync', () => {
                this.renderTotalWidgetChannels();
            });
        });
        this.options.manager.createModifyDashboardWidgetModal(this.options.widget);
    }

    renderTotalWidgetChannels() {
        var aggTypes = this.options.widget.getParamValue('CHART_AGGREGATION_TYPE', '').split(',');
        var channels = <DashboardChannel[]>this.options.dashboardChannelCollection.where({ dashboard_widget_id: this.options.widgetId });
        var channelsToRender = [];

        var sorted = _.sortBy(channels, (c) => {
            return c.get('dashboard_channel_order')
        });
        _.each(sorted, (channel: any, i) => {
            var id = channel.get('dashboard_channel_id');

            // timestamp is always index 0
            var datapoint = this.datapoints[id] && this.datapoints[id].length === 2 ? this.datapoints[id][1] : 'No Data';
            const decimals = this.getFormatDecimals(channel.get('channel_decimals'), datapoint);
            var value = typeof (datapoint) === 'number' ? this.getFormattedValue(datapoint, decimals) : datapoint;
            var state = this.getStateFromRange(channel, value);

            let channelLabel = channel.get('dashboard_channel_name');
            if(!this.useCustomLabels) channelLabel = `${channel.get('module_location')} - ${channel.get('channel_name')}`;

            channelsToRender.push({
                name: channelLabel,
                unit: typeof (datapoint) === 'number' ? channel.get('channel_unit') : '',
                value: value,
                aggFunctionName: getAggFunctionName((aggTypes[i])),
                id: id,
                color: state.color,
                state: state.name,
            });
        });

        if (!channelsToRender.length) {
            channelsToRender = [{
                name: '',
                unit: '',
                value: 'No Data',
                aggFunctionName: '',
                id: null,
                state: null,
            }];
            this.$('.total-widget').html(this.channelsTemplate({
                channels: channelsToRender,
                // Adjust channel widths for total widgets
                channelWidth: this.options.report && _.size(channelsToRender) > 2 ?
                    '33%' : this.options.report && _.size(channelsToRender) > 1 ?
                        '50%' : '100%',
                loading: false,
            }));

        } else {
            this.$('.total-widget').html(this.channelsTemplate({
                channels: channelsToRender,
                // Adjust channel widths for total widgets
                channelWidth: this.options.report && _.size(channelsToRender) > 2 ?
                    '33%' : this.options.report && _.size(channelsToRender) > 1 ?
                        '50%' : '100%',
                loading: false,
            }));
            var renderedChannelIds = <number[]>_.map(channelsToRender, 'id');
            if (this.lastRenderedChannelIds.length !== renderedChannelIds.length
                || _.difference(this.lastRenderedChannelIds, renderedChannelIds).length !== 0) {
                window['App'].Bus.trigger('dashboard:category:' + this.options.categoryId + ':layout');
            }
            this.lastRenderedChannelIds = renderedChannelIds;
        }
    }

    getStateFromRange(channel: DashboardChannel, value) {
        var range = channel.getRange();
        var color = Utils.colors.green;
        var name = 'Good';
        var arrow = null;
        if (range) {
            color = range.get('color');
            name = range.get('name');

            if (range.get('description').toLowerCase() == 'value below threshold') {
                arrow = 'down';
            } else if (range.get('description').toLowerCase() == 'value above threshold') {
                arrow = 'up';
            }
        }

        return {
            color: color,
            name: name,
            arrow: arrow
        };
    }

    getFormatDecimals(realDecimals, value) {
        if (realDecimals === null) {
            if (value > 10e9) {
                return 6;
            } else {
                if ((value < 0 && value > -10)) {
                    return 3;
                } else if ((value < 10 && value >= 0) || (value > -10 && value < 0)) {
                    return 2;
                } else if ((value < 100 && value > 0) || (value > -100 && value < 0)) {
                    return 1;
                } else {
                    return 0;
                }
            }
        } else {
            return realDecimals;
        }
    }

    getFormattedValue(value, decimals) {
        const MAX_NUMBER_DIGITS = 11;
        const ln10 = 2.302585092994046;

        if (_.isNull(value) || _.isUndefined(value) || _.isNaN(value)) return value;

        // Make sure the total number of digits doesn't exceed MAX_NUMBER_DIGITS. Otherwise show it as an exponential
        if ((Math.floor(Math.log(value) / ln10) + 1 + decimals) > MAX_NUMBER_DIGITS) {
            return value.toExponential(decimals);
        } else {
            return value.toFixed(decimals);
        }
    }

    remove() {
        // Terminate web workers and unload everything
        this.destroy();

        return super.remove();
    }

    destroy() {
        this.minDataRequested = Infinity;
        this.maxDataRequested = null;
        this.totalledDashboardChannelIds = [];
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/reports/widgets/totalwidget/TotalWidgetView.ts